import { render, staticRenderFns } from "./RolesEditModal.vue?vue&type=template&id=1113e63b&scoped=true"
import script from "./RolesEditModal.vue?vue&type=script&lang=js"
export * from "./RolesEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1113e63b",
  null
  
)

export default component.exports